module.exports = __webpack_public_path__ + "static/media/18.52b9ecd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/18.jpg
// module id = 551
// module chunks = 0